import TwoColumnContent from '../../../components/TwoColumnContent/TwoColumnContent';
import LeftColumn from '../../../components/TwoColumnContent/LeftColumn/LeftColumn';
import TitleDescription from '../../../components/TitleDescription/TitleDescription';
import RightColumn from '../../../components/TwoColumnContent/RightColumn/RightColumn';
import styles from '../EditTeamMember.module.css';
import React from 'react';
import { useIntl } from 'react-intl';
import { useEditTeamMember } from '../EditTeamMemberContext';

export const EditTeamMemberMultiFormAuth = () => {
  const intl = useIntl();
  const t = id => intl.formatMessage({ id });

  const { user, setUser, company } = useEditTeamMember();

  return (
    <TwoColumnContent bottomBorder={true}>
      <LeftColumn>
        <TitleDescription title={t('EditTeamMember.mfa.title')} description={t('EditTeamMember.mfa.details')} />
      </LeftColumn>
      <RightColumn>
        <div className={`${styles.checkInput} ${styles.mfa} d-flex align-items-center`}>
          <label htmlFor="useMfa" className="m-0">
            {t('EditTeamMember.mfa.label')}
          </label>
          <input
            style={{ marginLeft: '20px' }}
            id="useMfa"
            type="checkbox"
            checked={user.useMfa}
            disabled={company.requireMfa}
            onChange={e => setUser({...user, useMfa: e.currentTarget.checked})}
          />
        </div>
      </RightColumn>
    </TwoColumnContent>
  );
};
